export class CustomParamsOrganizationTypeModel {
  OrganizationTypeId: number
}
